// Primary Colors
export const havelViolet = '#36286d';
export const brickRed = '#e63331';

// Secondary Colors
export const markishGreen = '#00a770';
export const spreeBlue = '#6e9dd4';
export const electricYellow = '#fabd50';
export const dynamicOrange = '#ea5b1a';

// Shades of Havel Violet
export const havelVioletLight1 = '#c2bed3';
export const havelVioletLight2 = '#726898';
export const havelVioletDark1 = '#2b2057';
export const havelVioletDark2 = '#1b1436';

// Shades of Brick Red
export const brickRedLight1 = '#fad6d5';
export const brickRedLight2 = '#ed706e';
export const brickRedDark1 = '#a12322';
export const brickRedDark2 = '#5c1413';

// Shades of Markish Green
export const markishGreenLight1 = '#b2e4d4';
export const markishGreenLight2 = '#7fd3b7';
export const markishGreenDark1 = '#00744e';
export const markishGreenDark2 = '#003221';

// Shades of Spree Blue
export const spreeBlueLight1 = '#d3e1f2';
export const spreeBlueLight2 = '#a8c4e5';
export const spreeBlueDark1 = '#4d6d94';
export const spreeBlueDark2 = '#2c3e54';

// Shades of Electric Yellow
export const electricYellowLight1 = '#fdebca';
export const electricYellowLight2 = '#fcd796';
export const electricYellowDark1 = '#967130';
export const electricYellowDark2 = '#4b3818';

// Shades of Dynamic Orange
export const dynamicOrangeLight1 = '#f8cdba';
export const dynamicOrangeLight2 = '#f08c5e';
export const dynamicOrangeDark1 = '#a33f12';
export const dynamicOrangeDark2 = '#461b07';
